<template lang="pug">
include /mixins

+b.c-calendar
  +e.header
    +e.navigation
      +b.c-calendar-controls
        +e.arrow(@click="changeMonth(-1)")
          +b.icon-chevron-left
        +e.arrow(@click="changeMonth(1)")
          +b.icon-chevron-right
        +e.label {{ currentMonth }} {{ currentYear }}
    +e.today(@click="setToday") {{ _("Поточний місяць") }}
  +e.wrapper
    +e.grid
      +e.weekday(v-for="day in weekdays") {{ day }}
    +e.grid
      +e.day-wrapper(
        v-for="day in daysInMonth"
        :class="{ 'is-other-month': day.isOtherMonth }"
      )
        +e.day-label(:class="{ 'is-today': day.isToday }")
          +e.SPAN.day-number {{ day.day }}
        +e.event-wrapper
          calendar-events-list(
            :items="getEventsForDay(day.date)"
            :clamped="true"
            @event:select="showEventDetails"
            @event:more="showMoreEvents(day.date)"
          )
        //- +b.blur.--variant_2.is-active(v-if="moreEventsMap[day.date]")
        +b.c-more-events(
          v-if="moreEventsMap[day.date]"
          v-click-outside="closeMoreEvents"
        )
          +b.i-close.--variant_rounded.--color_white(@click="closeMoreEvents")
            +b.I.icon-close
          +e.heading
            +b.P.ds-caption.--size_2sm.--color_black.--appearance_center {{ day.day }}
            +b.P.ds-caption.--size_lg.--color_black.--bold.--appearance_center {{ getEventWeekday(day.date) }}
          +e.content
            calendar-events-list(
              :items="getEventsForDay(day.date)"
              :clamped="false"
              @event:select="showEventDetails"
            )
    +b.blur.--variant_1.is-active(v-if="selectedEvent")
    +b.c-event-details(
      v-if="selectedEvent"
      v-click-outside="closeDetails"
    )
      +b.i-close(@click="closeDetails")
        +b.I.icon-close
      slot(name="popup")
</template>

<script>
import CalendarEventsList from './components/Events'

export default {
  components: {
    'calendar-events-list': CalendarEventsList,
  },

  props: {
    events: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentDate: new Date(),
      selectedDate: null,
      selectedEvent: null,
      moreEventsMap: {},
      weekdays: [
        this._('Пн'),
        this._('Вт'),
        this._('Ср'),
        this._('Чт'),
        this._('Пт'),
        this._('Сб'),
        this._('Вс'),
      ],
    }
  },

  computed: {
    currentMonth() {
      return this.currentDate.toLocaleString('uk', { month: 'long' })
    },

    currentYear() {
      return this.currentDate.getFullYear()
    },

    daysInMonth() {
      const days = []
      const firstDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1)
      const lastDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0)

      const firstDayOfWeek = firstDay.getDay()
      const firstDayOfWeekPrepared = this.prepareWeekDay(firstDayOfWeek)

      const totalDays = lastDay.getDate()

      const prevMonthLastDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 0).getDate()

      for (let i = firstDayOfWeekPrepared; 0 < i; i--) {
        days.push({
          day: prevMonthLastDay - i + 1,
          isOtherMonth: true,
          date: new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, prevMonthLastDay - i + 1),
        })
      }

      for (let i = 1; i <= totalDays; i++) {
        const date = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), i)

        days.push({
          day: i,
          isOtherMonth: false,
          isToday: date.toDateString() === new Date().toDateString(),
          date,
        })
      }

      const remainingDays = (7 - (days.length % 7)) % 7

      for (let i = 1; i <= remainingDays; i++) {
        days.push({
          day: i,
          isOtherMonth: true,
          date: new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, i),
        })
      }

      return days
    },
  },

  methods: {
    setDate(val) {
      this.currentDate = val
    },

    prepareWeekDay(firstDayOfWeek) {
      return (0 === firstDayOfWeek) ? 6 : firstDayOfWeek - 1
    },

    emitDate() {
      this.$emit('month:change', this.currentDate)
    },

    changeMonth(val) {
      this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + val, 1)

      this.emitDate()
    },

    setToday() {
      this.currentDate = new Date()

      this.selectedDate = null

      this.emitDate()
    },

    getEventsForDay(date) {
      return this.events.filter(event => event.date.toDateString() === date.toDateString())
    },

    getEventWeekday(date) {
      const firstDayOfWeek = date.getDay()
      const firstDayOfWeekPrepared = this.prepareWeekDay(firstDayOfWeek)

      return this.weekdays[firstDayOfWeekPrepared]
    },

    async showEventDetails(event) {
      if (this.selectedEvent?.id === event?.id) {
        this.selectedEvent = null
      } else {
        this.selectedEvent = event
      }

      this.$emit('event:select', this.selectedEvent)

      this.closeMoreEvents()
    },

    closeDetails() {
      this.showEventDetails(null)
    },

    showMoreEvents(k) {
      this.closeMoreEvents()

      this.$set(this.moreEventsMap, k, true)
    },

    closeMoreEvents() {
      this.moreEventsMap = {}
    },
  },
}
</script>
